<div class="sales-list">
    @for(sale of sales(); track $index) {
    <commercial-sale-item [sale]="sale"></commercial-sale-item>
    }
</div>
